var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpeechValidatiion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 144,
  height: 135,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 112,
  height: 122,
  x: 16,
  y: 1,
  stroke: "#333",
  strokeWidth: 2,
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 41,
  x: 26,
  y: 32,
  stroke: "#333",
  strokeWidth: 2,
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#333",
  strokeWidth: 2,
  d: "M1 111a3 3 0 0 1 3-3h14v15H4a3 3 0 0 1-3-3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#333",
  strokeWidth: 2,
  d: "M17 115.5C17 105.283 25.283 97 35.5 97h8.237A2.263 2.263 0 0 1 46 99.263v32.474A2.263 2.263 0 0 1 43.737 134H35.5c-10.217 0-18.5-8.283-18.5-18.5ZM143 111a3 3 0 0 0-3-3h-14v15h14a3 3 0 0 0 3-3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#772432",
  strokeWidth: 2,
  d: "M99 105H80a4 4 0 0 0 0 8h19zM99 119H80a4 4 0 0 0 0 8h19z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#333",
  strokeWidth: 2,
  d: "M127 115.5c0-10.217-8.283-18.5-18.5-18.5h-8.237A2.263 2.263 0 0 0 98 99.263v32.474a2.263 2.263 0 0 0 2.263 2.263h8.237c10.217 0 18.5-8.283 18.5-18.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M17 16h110M25 8h5M35 8h5M75 36h40M75 44h40M75 52h40M75 60h20M109 8h10"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#772432",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M64 97V86.5M70.288 97.463l7.425-7.425M57.713 97.463l-7.425-7.425"
})));
export { SvgSpeechValidatiion as ReactComponent };
export default __webpack_public_path__ + "afec11609d3063549f7906c4a55954b1.svg";